var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mt-2 tw-self-end",attrs:{"id":"report-claim","small":"","color":"#fff"},on:{"click":function($event){return _vm.$root.$emit('modal-opened-claims')}}},[_vm._v("Report a Claim")]),_c('claims-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }